import { getUrl } from '../../../../utils/get-url.js';
import { getComponentByPath } from '../../../../utils/get-component-by-path.js';

/** Returns the main-menu data from the page model */ function getMainMenuItems(pageModel) {
    var ref;
    const menu = getComponentByPath('header/main-menu', pageModel);
    var _siteMenuItems;
    return (_siteMenuItems = menu === null || menu === void 0 ? void 0 : (ref = menu.models) === null || ref === void 0 ? void 0 : ref.menu.siteMenuItems) !== null && _siteMenuItems !== void 0 ? _siteMenuItems : [];
}
/** Returns the name that belongs to a given route from the main menu */ function getNameByProductRoute(categoryRoute, pageModel) {
    const menu = getMainMenuItems(pageModel);
    const route = findRouteByUrl(categoryRoute, menu);
    return route && route.name;
}
/**  Returns the route for a given url and an array of menu items */ function findRouteByUrl(categoryRoute, routes) {
    for (const route of routes){
        var ref, ref1;
        if (((ref = route._links.site) === null || ref === void 0 ? void 0 : ref.href) && ((ref1 = route._links.site) === null || ref1 === void 0 ? void 0 : ref1.href) === categoryRoute) {
            return route;
        }
        // Check the childMenuItems for the route
        if (route.childMenuItems.length) {
            const result = findRouteByUrl(categoryRoute, route.childMenuItems);
            if (result) return result;
        }
    }
}
function createCategoryBreadcrumb(pageModel, categoryRoute, page) {
    if (!pageModel || !categoryRoute) {
        return null;
    }
    const name = getNameByProductRoute(categoryRoute, pageModel);
    const url = getUrl(categoryRoute, page);
    return name ? {
        name,
        url
    } : null;
}

export { createCategoryBreadcrumb, getNameByProductRoute };
//# sourceMappingURL=create-category-breadcrumb.js.map
